import {Pipe, PipeTransform} from '@angular/core';
import {FiuDto, UserDto} from "@esa/api";

@Pipe({
  name: 'filterFiuPipe'
})
export class FilterFiuPipe implements PipeTransform {
  transform(fius: FiuDto[], currentUser?: UserDto, customFiu?: string, excludeCodes?: string[]): FiuDto[] {
    return fius.filter(fiu => {
      const isNotCurrentUserFiu = !currentUser || fiu?.id != currentUser?.fiuId;
      const isNotExcludedCode = !excludeCodes || !excludeCodes.includes(fiu?.logo);
      return isNotCurrentUserFiu && isNotExcludedCode;
    });
  }
}
